// extracted by mini-css-extract-plugin
module.exports = {"cookie_bar":"cookie-bar_cookie_bar__XLi3n","container":"cookie-bar_container__294UM","text_block":"cookie-bar_text_block__-pWgt","link":"cookie-bar_link__SqgGz"};